import { AnyAction } from 'redux';
import { handleActions } from 'redux-actions';

import { onboardingDataAction } from './SharedActionConfig';

// reducers
const defaultState = {
  countries: [],
  industries: [],
  roles: [],
};

type State = typeof defaultState;

const reducer = handleActions<State, AnyAction>({
  [`${onboardingDataAction}`](state, { payload }: AnyAction) {
    const { countries, industries, roles } = payload.data;
    return {
      ...state,
      countries,
      industries: industries?.sort(),
      roles: roles?.sort(),
    };
  },
}, defaultState);

export default reducer;
